<template>
  <div class="dialog-wrap">
    <el-dialog
      title="返佣类型添加"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="140px">
        <el-form-item label="返佣类型" prop="product_type">
          <el-select v-model="dataForm.product_type" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单笔交易返佣比" prop="charge_rate">
          <el-input v-model="dataForm.charge_rate" type="number" min="0" placeholder="输入单笔交易费用比"></el-input>
        </el-form-item>
        <el-form-item label="单笔交易固定返佣" prop="charge_amount">
          <el-input v-model="dataForm.charge_amount" type="number" min="0" placeholder="输入单笔交易固定费用"></el-input>
        </el-form-item>
      </el-form>
      <p class="tips">Tips: 固定返佣大于0时，将优先采用固定返佣计算</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { marketingChargeCreate } from '@/api/operation'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      types: [
        {label: '课程', value: 1},
        {label: '题库', value: 2},
        {label: '阅读资料', value: 3},
        {label: '实体资料', value: 4}
      ],
      rules: {
        product_type: [{ required: true, message: '请输入返佣类型', trigger: 'blur' }],
        charge_rate: [{ required: true, message: '请输入单笔交易费用比', trigger: 'blur' }],
        charge_amount: [{ required: true, message: '请输入单笔交易固定费用', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
    },
    content (list) {
      list.forEach(item => {
        this.types.some(type => {
          if (type.value == item.product_type) {
            type.disabled = true
            return true
          }
        })
      })
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = {
            product_type: this.dataForm.product_type,
            charge_rate: Number(this.dataForm.charge_rate),
            charge_amount: Number(this.dataForm.charge_amount)
          }
          marketingChargeCreate(params).then(res => {
            this.$message.success(`添加成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;
    }
    .tips {
      text-align: center;
      font-size: 12px;
      color: #a2a2a2;
      margin-top: 50px;
    }
  }
</style>
